export function vw($px) {
    return ($px / 750) * 100 + 'vw';
}